module.exports = __webpack_public_path__ + "stylesheets/fonts-basic_3dbd2a8d0c5d36f2d8a9480263afc354.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/fonts/fonts-basic.less
// module id = tWLz
// module chunks = 55 56